/**
 *  scrollspy (bootstrap-v4-alpha) 関連のjs
 *  http://v4-alpha.getbootstrap.com/components/scrollspy/
 */

import getHeaderSize from './getHeaderSize';

const scrollSpyCtrl = () => {
  const $body = $('body');
  const $target = $('#collapse-navbar');
  $body.scrollspy({ target: $target, offset: getHeaderSize($target) });

  $(window).on('resize', () => {
    $body.scrollspy('refresh');
  });
};

export default scrollSpyCtrl;



// WEBPACK FOOTER //
// ./src/scripts/common/scrollSpyCtrl.js